import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { Input, Textarea } from "components/shared/FormComponents";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const EditLink = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug } = useParams();
  const { loading, error, section } = useSelector((state) => state.section);
  const [isActive, setIsActive] = useState(false);
  const linkActivationHandler = () => setIsActive(!isActive);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  // effects
  useEffect(() => {
    dispatch(getSection({ page: "links", slug }));
  }, [dispatch, slug]);

  useEffect(() => {
    reset({
      heading: section?.heading,
      link: section?.link,
    });
    setIsActive(section?.isActive);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.isActive = isActive;
    dispatch(
      editSection({
        slug,
        page: "links",
        data: { section: data },
        navigate,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"editLink"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col>
                {/* heading  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.en"
                      register={register}
                      errors={errors}
                      dir="ltr"
                    />
                  </Col>
                  <Col xs={12} lg={6}>
                    <Input
                      langId="link"
                      name="link"
                      register={register}
                      errors={errors}
                      dir="ltr"
                      style={{ textTransform: "lowerCase" }}
                    />
                  </Col>
                  <Col lg={6} xs={12} className="d-flex align-items-center">
                    <div className="only-radio toggle-switch  ">
                      <label
                        className="switch-label"
                        htmlFor="sectionActivition"
                      >
                        <FormattedMessage id="linkActivation" />
                      </label>
                      <label className="switch" htmlFor="sectionActivition">
                        <input
                          id="sectionActivition"
                          type="checkbox"
                          checked={isActive}
                          onChange={linkActivationHandler}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} xs={12}>
                    <div className="form-group mt-4">
                      <button type="submit" className="btn btn-blue">
                        <FormattedMessage id={"edit"} />
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditLink;
